import appConfig from "../appconfig";
import ProductSelection from "../domains2/orders/ProductSelection";
import {
	ADD_PRODUCT_SELECTION_TO_CART,
	ADD_TO_CART_SINGLE_ITEM,
	CHECKOUT_RESET_WITH_LAST_UPDATE_TIME,
	SET_PICKED_RECOMMENDED_PRODUCTS
} from "../store/mutation-types";
import {copyObject} from "../domains2/libraries/Utils";
import {getPrice, RCMSourceType} from "../libraries/utils";
import HelloRetail from "../integrations/recommendations/helloRetail/HelloRetail";
import {pushGTMeCommerceData} from "../integrations/tracking/gtm/pushGTMeCommerceData";
import {hasGroupsOrConfigurations} from "../helper/ProductHelper";
import mutationTypesBM100 from "../store/globalTemplateSpecificModules/storeModulesBM100/mutationTypesBM100";

export default {
	methods: {
		createComplexProductSelection(item) {
			const psOptions = {
				expiration: {
					tenantSettings: this.tenantSettings.productSelectionExpiration,
					tenantConfig: appConfig.tenantConfig.productSelectionExpiration
				}
			};
			const productSelection = ProductSelection.createFromProduct(item, psOptions);
			ProductSelection.ChangeQuantity(productSelection, item, 1);
			const productGroup = this.productCatalog.getProduct(productSelection.productId).groups.find(g => g.appearance === "single");
			if (productGroup !== undefined && productGroup !== null) {
				const selectedProducts = productSelection.groups
					.find(g => g.groupId === productGroup.id).selectedProducts;
				const productId = selectedProducts[0];
				selectedProducts.splice(selectedProducts.indexOf(productId), 1);
				const product = this.productCatalog.getProduct(productId);
				selectedProducts.push({
					productId: product.id,
					groups: product.groups.map(g => {
						return {
							groupId: g.id,
							selectedProducts: []
						};
					}),
					configurations: [
						...product.configurations
							.filter(config => config.appearance === "checklist")
							.map(config => {
								const selectedValue = config.options.defaultSelectedArray ? config.options.defaultSelectedArray : [];
								return {
									configurationId: config.id,
									selectedValue: selectedValue
								};
							})]
				});
			}
			return productSelection;
		},
		async addToBasket(product) {
			if (this.selections.findIndex(item => item.productId === product.id) >= 0) {
				this.productSelection = this.selections.find(item=>item.productId === product.id);
				this.orderLine = this.orderLines.find(item => item.productId === product.id);
				this.receiptLine = this.receiptLines.find(item => item.productId === product.id);
				this.product = this.productCatalog.getProduct(product.id);
				await this.changeQuantity(this.productSelection.quantity + 1, true);
				return;
			}
			if(product.departmentId === 2) {
				const item = this.productCatalog.getProduct(product.id);
				const ps = this.createComplexProductSelection(item);
				ps.forceNewInCart = true;
				await this.$store.dispatch(ADD_TO_CART_SINGLE_ITEM, copyObject(ps));
				await this.$store.dispatch(CHECKOUT_RESET_WITH_LAST_UPDATE_TIME);
				return;
			}

			const psOptions = {
				expiration: {
					tenantSettings: this.tenantSettings.productSelectionExpiration,
					tenantConfig: appConfig.tenantConfig.productSelectionExpiration
				}
			};

			const productSelection = ProductSelection.createFromProduct(product, psOptions);
			productSelection.quantity = productSelection.quantity || 1;
			productSelection.rcmSource = RCMSourceType.Carousel;
			this.$store.dispatch(ADD_PRODUCT_SELECTION_TO_CART, productSelection);

			if(this.$router.currentRoute.path === "/") {
				await this.$store.dispatch(mutationTypesBM100.INDICATE_ADD_TO_BASKET, true);
			}

			if(this.shouldShowCarousel && this.recommendedProductsList.length && this.experimentId) {
				const pickedRecommendation = this.recommendedProducts.find(p => p.itemNumber === product.id);
				if(pickedRecommendation && pickedRecommendation.trackingCode) {
					HelloRetail.clickTracking(this, pickedRecommendation.trackingCode);
				}
				this.$store.commit(SET_PICKED_RECOMMENDED_PRODUCTS);
			}

			pushGTMeCommerceData({
				eventName: this.isProductCarouselContext ? "add_to_cart_carousel" : "add_to_cart",
				products: [{product}],
				category: this.productCatalog.getDepartment(product.departmentId),
				value: getPrice({product})
			});

			if(!hasGroupsOrConfigurations(product, this.productCatalog)) {
				HelloRetail.pageView(this, {productId: product.id});
			}
			HelloRetail.cartTracking(this);
		},
		findOrCreateProductSelection(product) {
			const isMenu = product.departmentId === 2;
			if (isMenu) {
				return [this.createComplexProductSelection(product)];
			}
			if (this.$store.getters.cartProducts) {
				const productSelections = this.$store.getters.selections.filter(selection => {
					return selection.productId === product.id;
				});
				if (productSelections.length) {
					return copyObject(productSelections);
				} else {
					const psOptions = {
						expiration: {
							tenantSettings: this.tenantSettings.productSelectionExpiration,
							tenantConfig: appConfig.tenantConfig.productSelectionExpiration
						}
					};
					const productSelection = ProductSelection.createFromProduct(product, psOptions);
					ProductSelection.ChangeQuantity(productSelection, product, 1);
					return [productSelection];
				}
			}
		}
	}
};
